// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.LazySelectDataSource.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import { LAZY_LOADING_DEFAULT_ITEMS_NUMBER } from 'logic/data/Izenda.UIConstants';
import { concatArray } from 'share/utils/Izenda.LazyLoadingUtils';
import { forEach, isFunction, map } from 'lodash/fp';

export default class LazySelectDataSource {
  mappingDefinitions: Array = null;
  propertyKey: string = null;
  isLastPage: boolean = false;
  skipItems: number = 0;
  pageSize: number = LAZY_LOADING_DEFAULT_ITEMS_NUMBER;

  @observable items = [];

  constructor(mappings, key) {
    mappings && (this.mappingDefinitions = mappings);
    key && (this.propertyKey = key);
  }

  /**
   * Populate detail (Almost data from API.)
   * @param {Object} detail
   */
  @action('setDetail')
  setDetail(detail) {
    this.skipItems = detail.skipItems;
    this.pageSize = detail.pageSize;
    this.isLastPage = detail.isLastPage;

    /**
     * Map source value to target based on mapping definition.
     */
    var mapFunc = () =>
      map(item => {
        var object = {};
        forEach(mapping => {
          var value = null;
          if (isFunction(mapping.source)) {
            value = mapping.source(item);
          } else {
            value = item[mapping.source];
          }
          object[mapping.target] = value;
        }, this.mappingDefinitions);

        return object;
      }, detail.items);

    concatArray(this.items, mapFunc(), this.propertyKey, !this.isLastPage);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.LazySelectDataSource.js